<script>
    import Game from './Game/index.svelte'
    
    import { Container, ScrollAnchor } from '@/components'
</script>

<Container>
    <ScrollAnchor id="game" />
    <h2 class="title scroll-element">Проверьте, как хорошо вы знакомы<br/>
    с кадровыми процессами обычной компании</h2>

    <div class="description">
        <p>Представьте, что вы сотрудник небольшой компании и хотите внепланово уехать отдохнуть.<br/> 
            Поездка запланирована через три недели. И чтобы она состоялась, нужно подать заявление на<br/> 
            отпуск в HR-отдел за две недели, в нашем случае — в ближайшую пятницу.</p>

        <p>Перетаскивайте карточки с действиями в свободные слоты и следите за развитием событий. Успех зависит не только от<br/> 
            вас, но и от того, как хорошо настроены кадровые процессы в компании. А ещё немного от удачи —<br/> 
            всё, как в жизни.</p>
    </div>

    <div class="game-wrapper">
        <Game />
    </div>
</Container>

<style lang="scss">
    .title {
        text-align: center;
        line-height: 60px;
    }

    .description {
        margin-top: 40px;
        text-align: center;
    }

    .game-wrapper {
        margin-top: 71px;
    }

    @media (max-width: 834px) {
        .title,
        .description {
            br {
                display: none;
            }
        }
    }
</style>